// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>12</span>&nbsp;&nbsp;They shall bear you in their hands,&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;lest you dash your foot against a stone.<br> </p> </div></div>";
// Exports
module.exports = code;